export const InitValue = {
  configButton: {
    size: 10,
    page: 0,
    tamanho: 0,
  },
  alterarOptions: {
    sede: 0,
    nomeSede: '',
    ministerio: 0,
    nomeMinisterio: '',
    celula: 0,
    nomeCelula: '',
    coordenador: 0,
  },
  filtrosDashboard: {
    pg: {
      sede: 0,
      descricaoSede: '',
      ministerio: 0,
      descricaoMinisterio: '',
      tipoCargo: '',
      descricaoCargo: '',
      dataInicial: '',
      dataFinal: '',
      tipoPg: 0,
      descricaoTipoPG: '',
      estado: 0,
      descricaoEstado: ''
    },
    batismo: {
      sede: 0,
      descricaoSede: '',
      batizado: 0,
      descricaoBatizado: '',
      dataInicial: '',
      dataFinal: ''
    },
    checkin: {
      sede: 0,
      sedeDescricao: '',
      dataInicial: '',
      dataFinal: ''
    },
    crm: {
      sede: 0,
      descricaoSede: '',
      ministerio: 0,
      descricaoMinisterio: '',
      tipoCargo: '',
      descricaoCargo: '',
      dataInicial: '',
      dataFinal: '',
      tipoPg: 0,
      descricaoTipoPG: '',
      estado: 0,
      descricaoEstado: ''
    },
    aplicar: true
  },
  filtros: {
    orientacaoFrente: -1,
    orientacaoTras: 1,
    orientacaoNulla: 0
  },
  menu: {
    status: true
  }
}

export type ConfigButton = {
  size?: 10,
  page?: 0,
  tamanho?: 0,
}

export type IAction = {
  type: string,
  dispatch: any
}

export interface IReducer {
  InitValue: any
  action: any
}

export default function Reducer(InitValue: any, action: any) {
  switch (action.type) {
    case "configButton_size":
      return { ...InitValue, configButton: { ...InitValue?.configButton, size: action.dispatch } }
    case "alterar_coordenador":
      return { ...InitValue, alterarOptions: { ...InitValue?.alterarOptions, coordenador: action.dispatch } }
    case "configButton_page":
      return { ...InitValue, configButton: { ...InitValue?.configButton, page: action.dispatch } }
    case "configButton_length":
      return { ...InitValue, configButton: { ...InitValue?.configButton, tamanho: action.dispatch } }
    case "alterar_sede":
      return { ...InitValue, alterarOptions: { ...InitValue?.alterarOptions, sede: action.dispatch } }
    case "alterar_ministerio":
      return { ...InitValue, alterarOptions: { ...InitValue?.alterarOptions, ministerio: action.dispatch } }
    case "alterar_celula":
      return { ...InitValue, alterarOptions: { ...InitValue?.alterarOptions, celula: action.dispatch } }
    case "alterar_orientacao":
      return { ...InitValue, filtros: { orientacaoFrente: InitValue?.filtros?.orientacaoFrente > 0 ? -1 : 1, orientacaoTras: InitValue?.filtros.orientacaoTras > 0 ? -1 : 1, orientacaoNulla: 0 } }
    case "change_menu":
      return { ...InitValue, menu: { status: InitValue.menu.status ? !InitValue.menu.status : true } }
    case "change_filtro_pg_sede":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, sede: action.dispatch } } }
    case "change_filtro_pg_desc_sede":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, descricaoSede: action.dispatch } } }
    case "change_filtro_pg_desc_ministerio":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, descricaoMinisterio: action.dispatch } } }
    case "change_filtro_pg_ministerio":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, ministerio: action.dispatch } } }
    case "change_filtro_pg_data_inicial":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, dataInicial: action.dispatch } } }
    case "change_filtro_pg_data_final":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, dataFinal: action.dispatch } } }
    case "change_filtro_checkin_sede":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, checkin: { ...InitValue?.filtrosDashboard.checkin, sede: action.dispatch } } }
    case "change_filtro_checkin_desc_sede":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, checkin: { ...InitValue?.filtrosDashboard.checkin, descricaoSede: action.dispatch } } }
   case "change_filtro_checkin_data_inicial":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, checkin: { ...InitValue?.filtrosDashboard.checkin, dataInicial: action.dispatch } } }
    case "change_filtro_checkin_data_final":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, checkin: { ...InitValue?.filtrosDashboard.checkin, dataFinal: action.dispatch } } }
    case "change_filtro_pg_tipopg":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, tipoPg: action.dispatch } } }
    case "change_filtro_pg_desc_tipopg":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, descricaoTipoPG: action.dispatch } } }
    case "change_filtro_pg_desc_estado":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, descricaoEstado: action.dispatch } } }
    case "change_filtro_pg_estado":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, estado: action.dispatch } } }
    case "change_filtro_pg_tipoCargo":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, tipoCargo: action.dispatch } } }
    case "change_filtro_pg_desc_tipoCargo":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, pg: { ...InitValue?.filtrosDashboard.pg, descricaoCargo: action.dispatch } } }
    case "change_filtro_batismo_sede":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, batismo: { ...InitValue?.filtrosDashboard.batismo, sede: action.dispatch } } }
    case "change_filtro_batismo_desc_sede":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, batismo: { ...InitValue?.filtrosDashboard.batismo, descricaoSede: action.dispatch } } }
    case "change_filtro_batismo_data_inicial":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, batismo: { ...InitValue?.filtrosDashboard.batismo, dataInicial: action.dispatch } } }
    case "change_filtro_batismo_data_final":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, batismo: { ...InitValue?.filtrosDashboard.batismo, dataFinal: action.dispatch } } }
    case "change_filtro_batismo_batizado":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, batismo: { ...InitValue?.filtrosDashboard.batismo, batizado: action.dispatch } } }
    case "change_filtro_batismo_desc_batizado":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, batismo: { ...InitValue?.filtrosDashboard.batismo, descricaoBatizado: action.dispatch } } }
    case "change_filtro_aplicar":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, aplicar: !InitValue?.filtrosDashboard.aplicar } }
      case "change_filtro_crm_sede":
        return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, sede: action.dispatch } } }
      case "change_filtro_crm_desc_sede":
        return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, descricaoSede: action.dispatch } } }
      case "change_filtro_crm_desc_ministerio":
        return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, descricaoMinisterio: action.dispatch } } }
      case "change_filtro_crm_ministerio":
        return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, ministerio: action.dispatch } } }
      case "change_filtro_crm_data_inicial":
        return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, dataInicial: action.dispatch } } }
      case "change_filtro_crm_data_final":
        return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, dataFinal: action.dispatch } } }
        case "change_filtro_crm_tipopg":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, tipoPg: action.dispatch } } }
    case "change_filtro_crm_desc_tipopg":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, descricaoTipoPG: action.dispatch } } }
    case "change_filtro_crm_desc_estado":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, descricaoEstado: action.dispatch } } }
    case "change_filtro_crm_estado":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, estado: action.dispatch } } }
    case "change_filtro_crm_tipoCargo":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, tipoCargo: action.dispatch } } }
    case "change_filtro_crm_desc_tipoCargo":
      return { ...InitValue, filtrosDashboard: { ...InitValue?.filtrosDashboard, crm: { ...InitValue?.filtrosDashboard.crm, descricaoCargo: action.dispatch } } }
    case "change_filtro_desaplicar":
      return {
        ...InitValue, filtrosDashboard: {
          ...InitValue?.filtrosDashboard, aplicar: !InitValue?.filtrosDashboard.aplicar, pg: {
            sede: 0,
            descricaoSede: '',
            ministerio: 0,
            descricaoMinisterio: '',
            tipoCargo: '',
            descricaoCargo: '',
            dataInicial: '',
            dataFinal: '',
            tipoPg: 0,
            descricaoTipoPG: '',
            estado: 0,
            descricaoEstado: ''
          },
          batismo: {
            sede: 0,
            descricaoSede: '',
            batizado: 0,
            descricaoBatizado: '',
            dataInicial: '',
            dataFinal: ''
          },
          checkin: {
            sede: 0,
            sedeDescricao: '',
            dataInicial: '',
            dataFinal: ''
          },
          crm: {
            sede: 0,
            descricaoSede: '',
            ministerio: 0,
            descricaoMinisterio: '',
            dataInicial: '',
            dataFinal: ''
          },
        }
      }
    default:
      return
  }
}
